"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _BETPortalObjectsStore = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/stores/BETPortalObjectsStore"));

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var BETAssociatedPortalObjectsDependency = {
  stores: [_BETPortalObjectsStore.default],
  deref: function deref(_ref) {
    var interaction = _ref.interaction,
        engagement = _ref.engagement,
        BETAssociatedPortalObjects = _ref.BETAssociatedPortalObjects;

    if (!_ScopesContainer.default.isScoped('bet-portal-association-access')) {
      return (0, _immutable.List)();
    }

    if (BETAssociatedPortalObjects) {
      return BETAssociatedPortalObjects;
    }

    var engagementId = interaction && interaction.getIn(['engagement', 'id']) || engagement && engagement.getIn(['engagement', 'id']);

    if (!engagementId) {
      return (0, _immutable.List)();
    }

    return _BETPortalObjectsStore.default.get((0, _immutable.Map)({
      objectType: _ObjectTypes.ENGAGEMENT,
      subjectId: engagementId
    })) || (0, _immutable.List)();
  }
};
var _default = BETAssociatedPortalObjectsDependency;
exports.default = _default;
module.exports = exports.default;